import React from 'react';
import LegalLayout from './LegalLayout';
import { Mail, ShieldAlert, HelpCircle, Sparkles } from 'lucide-react';

export default function ContactUs() {
  const contacts = [
    {
      title: "General Inquiries",
      description: "For all general questions, media, or cosmic greetings.",
      email: "hello@sacredmothr.com",
      icon: <Sparkles size={20} color="#eab308" />
    },
    {
      title: "Voyager Support",
      description: "Experiencing turbulence? Reach out for technical or account assistance.",
      email: "support@sacredmothr.com",
      icon: <HelpCircle size={20} color="#38bdf8" />
    },
    {
      title: "Administrative",
      description: "For partnerships, legal, and operational matters.",
      email: "admin@sacredmothr.com",
      icon: <Mail size={20} color="#a78bfa" />
    },
    {
      title: "Privacy & Data",
      description: "Inquiries regarding data compliance, erasure, and telemetry privacy.",
      email: "privacy@sacredmothr.com",
      icon: <ShieldAlert size={20} color="#4ade80" />
    }
  ];

  return (
    <LegalLayout title="Transmission & Contact" lastUpdated="30 May 2026">
      <p style={{ marginTop: '0' }}>
        Whether you require guidance through the Sanctuary or simply wish to send a transmission, our communication nodes are always open.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem', marginTop: '1rem' }}>
        {contacts.map((contact, index) => (
          <div key={index} style={{
            background: 'rgba(255, 255, 255, 0.03)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '16px',
            padding: '1.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            transition: 'all 0.2s ease',
            cursor: 'default'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.06)';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.08)';
          }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <div style={{ padding: '0.5rem', background: 'rgba(0,0,0,0.3)', borderRadius: '12px', display: 'flex' }}>
                {contact.icon}
              </div>
              <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700', color: 'var(--text-primary)' }}>{contact.title}</h3>
            </div>
            <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--text-muted)', lineHeight: '1.5' }}>
              {contact.description}
            </p>
            <a href={`mailto:${contact.email}`} style={{
              display: 'inline-block',
              marginTop: 'auto',
              paddingTop: '0.5rem',
              color: 'var(--text-primary)',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '0.9rem',
              letterSpacing: '0.5px'
            }}>
              {contact.email}
            </a>
          </div>
        ))}
      </div>
    </LegalLayout>
  );
}
